/* eslint-disable no-unused-expressions */
import React from "react";
import * as Icon from "react-feather";
import moment from "moment";
import { generateAppConfig } from "../config";


const horizontalDynamicConfig = (allowedNavigations) => {
  let isMobile = window.innerWidth < 1200

  // `showInMenu` defaults to true (missing/undefined => true)
  const menuAllowedNavigations = (allowedNavigations || []).filter(
    (item) => item?.moduleId && item.moduleId.showInMenu !== false
  );

  const resolveNavLink = (url) => {
    if (typeof url !== "string") return url;

    let userInfo = {};
    try {
      const userInfoRaw = localStorage.getItem("accessToken");
      userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : {};
    } catch (e) {
      userInfo = {};
    }
    const safe = (v) => encodeURIComponent(v == null ? "" : String(v));

    // Allow environment-based external links stored in DB.
    // Example: "${BOOKING_APP_URL}/?foo=bar" where BOOKING_APP_URL is set per server build.
    const bookingBase =
      (generateAppConfig && typeof generateAppConfig === "function"
        ? generateAppConfig()?.bookingAppRepoLocation
        : "") ||
      process.env.REACT_APP_BOOKING_APP_URL ||
      "";
    const withEnv = url
      .replace(/\$\{BOOKING_APP_URL\}/g, bookingBase)
      // User-based placeholders (for external booking links, etc.)
      .replace(/\$\{USER_ID\}/g, safe(userInfo?.userId))
      .replace(/\$\{TOKEN\}/g, safe(userInfo?.accessToken))
      .replace(/\$\{FIRST_NAME\}/g, safe(userInfo?.firstName))
      .replace(/\$\{LAST_NAME\}/g, safe(userInfo?.lastName));

    // If user stored only the base booking URL placeholder, automatically
    // build the standard booking link with userId/token (same shape as booking engine).
    const normalizedBase = String(bookingBase || "").replace(/\/+$/, "");
    const normalizedWithEnv = String(withEnv || "").replace(/\/+$/, "");
    const isBookingBaseOnly =
      url.includes("${BOOKING_APP_URL}") &&
      normalizedBase &&
      (normalizedWithEnv === normalizedBase) &&
      !/token=|userId=/i.test(withEnv);
    if (isBookingBaseOnly) {
      return `${normalizedBase}/?userId=${safe(userInfo?.userId)}&token=${safe(userInfo?.accessToken)}&firstName=${safe(userInfo?.firstName)}&lastName=${safe(userInfo?.lastName)}`;
    }

    // External links should be used as-is
    if (/^https?:\/\//i.test(withEnv)) return withEnv;
    if (withEnv === "/monthly-report") {
      return `${withEnv}?month=${moment().get("month")}&year=${moment().get("year")}`;
    }
    if (withEnv === "/guests-list") {
      return `${withEnv}/${moment().format("YYYY-MM-DD")}`;
    }
    return withEnv;
  };

  const isExternal = (url) => typeof url === "string" && /^https?:\/\//i.test(resolveNavLink(url));

  let topMenus = new Set(menuAllowedNavigations.filter(item => item?.moduleId?.topModuleName).sort((x, y) => x?.moduleId?.topModuleId?.priority - y?.moduleId?.topModuleId?.priority).map((data) => data?.moduleId?.topModuleName));
  let parentMenus = new Set(
    menuAllowedNavigations.map((data) => data?.moduleId?.parentModuleName)
  );
  let arrayList = [];

  Array.from(topMenus).map((item) => {
    let subname = [];
    menuAllowedNavigations.map((sval) => {
      if (item === sval?.moduleId?.topModuleName) {
        subname.push({
          topName: item,
          subName: sval?.moduleId?.parentModuleName || sval?.moduleId?.name,
        });
      }
    });
    let test = [];
    subname.forEach((val) => {
      if (test.length > 0 && !test.includes(val.subName)) {
        test.push(val.subName);
      } else if (test.length === 0) {
        test.push(val.subName);
      }
    });
    arrayList.push({ TName: subname[0].topName, sName: test });
  });

  let array = [];
  arrayList.map((menu) => {
    let navChild = [];
    menu.sName.forEach((child) => {
      menuAllowedNavigations.forEach((childData) => {
        // Only include modules that belong to the current top module.
        if (
          childData?.moduleId?.topModuleName === menu.TName &&
          child === childData?.moduleId?.parentModuleName
        ) {
          let obj2 = [];
          Array.from(parentMenus).map((subVal) => {
            menuAllowedNavigations.map((subdata) => {
              if (
                subdata?.moduleId?.topModuleName === menu.TName &&
                child === subdata?.moduleId?.parentModuleName
              ) {
                const resolved = resolveNavLink(subdata?.moduleId?.url);
                const navObj2 = {
                  id: subdata?.moduleId?._id,
                  title: subdata?.moduleId?.name,
                  type: isExternal(subdata?.moduleId?.url) ? "external-link" : "item",
                  icon: <Icon.Circle size={10} />,
                  permissions: ["admin", "editor"],
                  navLink: resolved,
                }
                if (navObj2.type === "external-link") navObj2.newTab = true;
                obj2.push(navObj2);
              }
            });
          });

          const navChildObj = {
            id: child,
            title: child,
            type: obj2?.length ? (isMobile ? "collapse" : "dropdown") : "item",
            icon: <Icon.Circle size={10} />,
            permissions: ["admin", "editor"],
            priority: childData?.moduleId?.parentModuleId?.priority,
          }
          if (obj2?.length) {
            navChildObj.children = [
              ...new Map(obj2.map((item) => [item.id, item])).values(),
            ];
          }

          navChild.push(navChildObj);
        } 
        if (
          childData?.moduleId?.topModuleName === menu.TName &&
          child === childData?.moduleId?.name
        ) {
          const navChildObj = {
            id: child,
            title: child,
            type: isExternal(childData?.moduleId?.url) ? "external-link" : "item",
            icon: <Icon.Circle size={10} />,
            permissions: ["admin", "editor"],
            navLink: resolveNavLink(childData?.moduleId?.url),
            priority: childData?.moduleId?.parentModuleId?.priority,
          }
          if (navChildObj.type === "external-link") navChildObj.newTab = true;

          navChild.push(navChildObj);
        }
      });
    });

    array.push({
      id: menu.TName,
      title: menu.TName,
      type: isMobile ? "collapse" : "dropdown",
      icon: <Icon.Settings size={16} />,
      // Try to keep top-level menus ordered by TopModule priority
      priority:
        menuAllowedNavigations.find((x) => x?.moduleId?.topModuleName === menu.TName)?.moduleId
          ?.topModuleId?.priority ?? 9999,
      children: [
        ...new Map(navChild.map((item) => [item.title, item])).values(),
      ],
    });
  });

  // App-modules without a Top Module should show as individual top-level items.
  const ungrouped = menuAllowedNavigations
    .filter((item) => !item?.moduleId?.topModuleName)
    .map((item) => ({
      id: item?.moduleId?._id,
      title: item?.moduleId?.name,
      type: isExternal(item?.moduleId?.url) ? "external-link" : "item",
      icon: <Icon.Settings size={16} />,
      permissions: ["admin", "editor"],
      navLink: resolveNavLink(item?.moduleId?.url),
      priority:
        typeof item?.moduleId?.menuPriority === "number"
          ? item.moduleId.menuPriority
          : item?.moduleId?.parentModuleId?.priority,
    }));
  ungrouped.forEach((i) => {
    if (i.type === "external-link") i.newTab = true;
  });

  const dedupedUngrouped = [
    ...new Map(ungrouped.filter((x) => x?.id).map((x) => [x.id, x])).values(),
  ].sort((a, b) => (a?.priority ?? 9999) - (b?.priority ?? 9999));

  array.push(...dedupedUngrouped);
  // Ensure consistent top-level ordering (ungrouped last)
  return array.sort((a, b) => (a?.priority ?? 9999) - (b?.priority ?? 9999));
};

export default horizontalDynamicConfig;
